var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimeframe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 25 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.471 2c.434 0 .786.332.786.741V5.2c0 .409-.352.74-.786.74-.434 0-.785-.331-.785-.74V2.74c0-.41.351-.741.785-.741ZM19.04 2c.434 0 .785.332.785.741V5.2c0 .409-.351.74-.785.74-.434 0-.786-.331-.786-.74V2.74c0-.41.352-.741.786-.741ZM3.067 8.164c0-.41.352-.742.786-.742h17.804c.434 0 .786.332.786.742 0 .409-.352.74-.786.74H3.853c-.434 0-.786-.331-.786-.74Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.067 8.164c0-.41.352-.742.786-.742h17.804c.434 0 .786.332.786.742 0 .409-.352.74-.786.74H3.853c-.434 0-.786-.331-.786-.74Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.563 4.704H5.947c-.868 0-1.571.664-1.571 1.483v12.848c0 .819.703 1.482 1.57 1.482h13.616c.867 0 1.57-.663 1.57-1.482V6.187c0-.819-.703-1.483-1.57-1.483ZM5.947 3.222c-1.736 0-3.142 1.327-3.142 2.965v12.848C2.806 20.672 4.212 22 5.948 22h13.614c1.736 0 3.142-1.328 3.142-2.965V6.187c0-1.638-1.406-2.965-3.142-2.965H5.948Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeframe);
export default __webpack_public_path__ + "static/media/timeframe.84d246e471464c516692ed60b739794c.svg";
export { ForwardRef as ReactComponent };